<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('technician.technicians') }}</router-link> /
            <span class="color-main">{{ $t('technician.addTechnician') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('technician.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('technician.addTechnicianTitle') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addtichvalid" v-model="valid" ref="form">
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('technician.nameAr') }}</h6>
                <v-text-field
                  type="text"
                  name="name[ar]"
                  :rules="defaultRoles"
                  :placeholder="$t('technician.nameArPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('technician.nameEn') }}</h6>
                <v-text-field
                  type="text"
                  name="name[en]"
                  :rules="defaultRoles"
                  :placeholder="$t('technician.nameEnPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mb-4">
                <h6 class="mb-2 font14">{{ $t('technician.specialization') }}</h6>
                <Dropdown
                  v-model="selectedSpecial"
                  :options="specials"
                  filter
                  optionLabel="name"
                  :placeholder="$t('technician.specializationPlaceholder')"
                  :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                  class="main-select"
                />
              </div>

              <div class="main-input-cont mt-1 mb-4">
                <h6 class="mb-2 font14">{{ $t('technician.buildingCodes') }}</h6>
                <MultiSelect
                  v-model="selectedbuilding"
                  display="chip"
                  :options="buildings"
                  optionLabel="ref_code"
                  :placeholder="$t('technician.buildingCodesPlaceholder')"
                  :maxSelectedLabels="20"
                  class="w-full md:w-20rem"
                />
              </div>

              <div class="main-input-cont mt-1 tel-input-me">
                <h6 class="mb-2 font14">{{ $t('technician.phone') }}</h6>
                <v-text-field
                  v-model="phone"
                  name="phone"
                  @input="checkPhoneValidation"
                  type="number"
                  min="0"
                  :placeholder="$t('technician.phonePlaceholder')"
                ></v-text-field>
                <div class="drop-countries">
                  <Dropdown
                    v-model="selectedCountry"
                    :options="countries"
                    optionLabel="name"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value" class="flex-group-me">
                        <img
                          :alt="slotProps.value.label"
                          :src="slotProps.value.image"
                          :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.value.key }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <div class="flex-group-me">
                        <img
                          :alt="slotProps.option.label"
                          :src="slotProps.option.image"
                          :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.option.key }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('technician.confirmAddTechnician') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('technician.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import axios from "axios";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const { t } = useI18n();

// reactive state
const selectedSpecial = ref(null);
const specials = ref([]);
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('technician.fieldRequired');
  },
]);

const selectedbuilding = ref(null);
const buildings = ref([]);
const selectedCountry = ref({
  key: "966",
  code: "SA",
  image:
    "https://backend.maak-lancer.com/public/storage/images/countries/1701785725_8987.png",
});
const countries = ref([]);
const valid = ref(false);
const disabled = ref(false);
const form = ref(null);

// functions
function addTechnicain() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  if (selectedCountry.value) {
    fd.append("country_code", Number(selectedCountry.value.key));
  }
  if (selectedSpecial.value) {
    fd.append("maintenance_type_id", selectedSpecial.value.id);
  }

  if (selectedbuilding.value) {
    for (let i = 0; i < selectedbuilding.value.length; i++) {
      fd.append(`buildings[${i}]`, selectedbuilding.value[i].id);
    }
  }

  axios
    .post("/manager/add-worker", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        setTimeout(function () {
          router.push("/TechniciansView");
        }, 500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
  });
}
function getSpecials() {
  axios.get("/user/maintenance-types").then((response) => {
    specials.value = response.data.data;
  });
}
function getBuildings() {
  axios
    .get("/manager/buildings", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      buildings.value = response.data.data;
    });
}

// addBuilding
function addtichvalid() {
  if (valid.value) {
    addTechnicain();
  } else {
    scrollToDanger();
  }
}

// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {
  getSpecials();
  getBuildings();
  getCountries();
});
</script>
